import dayjs from 'dayjs';

export interface DatePreset {
  value: string;
  label: string;
}

export function getDefaultDatePresets(): DatePreset[] {
  return [
    {value: dayjs().subtract(1, 'day').format('YYYY-MM-DD'), label: 'Yesterday'},
    {value: dayjs().format('YYYY-MM-DD'), label: 'Today'},
    {value: dayjs().add(1, 'day').format('YYYY-MM-DD'), label: 'Tomorrow'},
    {value: dayjs().add(1, 'week').format('YYYY-MM-DD'), label: 'Next week'},
    {value: dayjs().add(1, 'month').format('YYYY-MM-DD'), label: 'Next month'},
    {value: dayjs().add(1, 'year').format('YYYY-MM-DD'), label: 'Next year'},
  ];
}

export function resolvePresetToDate(value: string): Date {
  return dayjs(value).toDate();
}
